<template>
  <div class="flex flex-col">
    <SkeletonLoader
      width="100%"
      height="46px"
      class="h-[46px] relative lg:mx-0"
      :class="footerNewsletter ? 'max-w-xs mt-5' : 'w-full'"
    />
    <SkeletonLoader
      width="100%"
      height="48px"
      class="h-12 relative mt-6 lg:mt-8 lg:mx-0"
      :class="footerNewsletter ? 'max-w-xs' : 'w-full'"
    />
  </div>
</template>
<script lang="ts">

export default defineComponent({
  name: 'NewsletterFormInputsSkeleton',
  props: {
    footerNewsletter: {
      type: Boolean,
      default: false,
    },
  },
});

</script>
